import { Navigate, Outlet, useLocation } from 'react-router';
import Navbar from "./components/navigation/Navbar";
import Sidebar from "./components/navigation/Sidebar";
import { useAuthStore } from './store/authStore';

const PreLoginRoutes = () => {
    const { isAuthenticated } = useAuthStore()
    const { pathname } = useLocation();
    return !isAuthenticated ? (
        <Outlet />
    ) : (
        <Navigate to={"/"} state={{ from: pathname }} replace />
    );
}

export default PreLoginRoutes